module.exports = __webpack_public_path__ + "static/media/website.b9251b55.png";